/**
 * Which converter produced a model's metadata JSON. `scene` covers anything without a
 * recognisable per-format shape, including metaObjects synthesised from the xeokit MetaScene.
 */
export type MetadataFormat = 'ifc' | 'rvt' | 'step' | 'scene';

interface MetaObjectProbe {
  id: string | number;
  type?: string;
}

interface MetadataProbe {
  metaObjects?: MetaObjectProbe[];
  Elements?: unknown[];
}

/**
 * IFC is recognised by its type names, STEP by its entity ids (`#4368`, `#3567:0`) — IFC uses
 * GUIDs and RVT numeric ids, so neither collides. Types win: a model carrying `Ifc*` types is
 * IFC whatever its ids look like.
 */
export function metaObjectsFormat(metaObjects: MetaObjectProbe[]): MetadataFormat {
  if (metaObjects.some((metaObject) => metaObject.type?.startsWith('Ifc'))) return 'ifc';
  if (metaObjects.some((metaObject) => String(metaObject.id).startsWith('#'))) return 'step';
  return 'scene';
}

export function detectMetadataFormat(metadata: MetadataProbe | undefined | null): MetadataFormat {
  if (Array.isArray(metadata?.Elements)) return 'rvt';
  if (Array.isArray(metadata?.metaObjects)) return metaObjectsFormat(metadata.metaObjects);
  return 'scene';
}
